import { ComponentConfig } from "@measured/puck"
import { useState } from "react"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../lib/helper"

export type VideoProps = {
  linkVideo?: string
  image?: string
  borderRadius?: string
  heightMobile?: string
  heightTablet?: string
  heightDesktop?: string
  widthMobile?: string
  widthTablet?: string
  widthDesktop?: string
  className?: string
}

const convertVideoLink = (link?: string) => {
  if (!link) return ""

  const youtubeMatch = link.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  )
  if (youtubeMatch) return `https://www.youtube.com/embed/${youtubeMatch[1]}?rel=0`

  const facebookMatch = link.match(/(?:https?:\/\/)?(?:www\.)?facebook\.com\/.*\/videos\/(\d+)/)
  if (facebookMatch) return `https://www.facebook.com/video/embed?video_id=${facebookMatch[1]}`

  const tiktokMatch = link.match(/(?:https?:\/\/)?(?:www\.)?tiktok\.com\/@(\w+)\/video\/(\d+)/)
  if (tiktokMatch) return `https://www.tiktok.com/embed/${tiktokMatch[2]}`

  return link
}

export const RenderConfig: ComponentConfig<VideoProps> = {
  render: ({
    linkVideo,
    image,
    widthMobile,
    widthDesktop,
    heightMobile,
    heightDesktop,
    borderRadius,
    heightTablet,
    widthTablet,
    className,
  }) => {
    const id = `video-${Math.random().toString(36).substr(2, 9)}`
    const [isModalOpen, setIsModalOpen] = useState(false)

    const showModal = () => {
      setIsModalOpen(true)
    }

    const handleOk = () => {
      setIsModalOpen(false)
    }

    const handleCancel = () => {
      setIsModalOpen(false)
    }

    const [currentVideo, setCurrentVideo] = useState<string | undefined>("")

    const openVideoModal = () => {
      const embedLink = convertVideoLink(linkVideo)
      if (embedLink) {
        setCurrentVideo(embedLink)
        setIsModalOpen(true)
      }
    }

    const closeVideoModal = () => {
      setIsModalOpen(false)
      setCurrentVideo("")
    }

    const styles = {
      mobile: {
        height: heightMobile,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: widthMobile,
        borderRadius,
      },
      tablet: {
        height: heightTablet,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: widthTablet,
        borderRadius,
      },
      desktop: {
        height: heightDesktop,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: widthDesktop,
        borderRadius,
      },
    }

    return (
      <>
        {generateResponsiveCSS(id, styles || {})}
        <div id={id} className={`${id} ${twMerge(className)}`}>
          <div className="relative overflow-hidden rounded-xl sm:rounded-2xl w-full h-full cursor-pointer group">
            <iframe
              className=" w-full h-full"
              src={linkVideo}
              title="Video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </>
    )
  },
}
